import request from '@/api/axios'
import { apiList as api } from './apiList'

export function getArticleDetail(id) {
  return request({
    url: api.topic.getArticleDetail + id, // 获取文章详情
    method: 'get',
  })
}
